<template>
    <div class="language-switcher">
      <button
        @click="toggleLanguage"
        class="language-toggle-btn"
        :title="currentLanguage === 'en' ? 'Switch to Arabic' : 'Switch to English'"
      >
        {{ currentLanguage === 'en' ? 'AR' : 'EN' }}
      </button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LanguageSwitcher',
    computed: {
      currentLanguage() {
        return this.$i18n.locale
      }
    },
    methods: {
      switchLanguage(lang) {
        this.$i18n.locale = lang
        localStorage.setItem('lang', lang)
        
        // Update document direction for RTL support
        document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr')
        
        // Emit event for parent components
        this.$emit('language-changed', lang)
      },
      toggleLanguage() {
        const newLanguage = this.currentLanguage === 'en' ? 'ar' : 'en'
        this.switchLanguage(newLanguage)
      }
    }
  }
  </script>
  
  <style scoped>
  .language-switcher {
    display: flex;
    align-items: center;
  }
  
  .language-toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    border: 2px solid #F5BE32;
    background: transparent;
    color: #F5BE32;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;
    font-size: 14px;
    min-width: 50px;
    text-align: center;
  }
  
  .language-toggle-btn:hover {
    background: #F5BE32;
    color: #1F1F1F;
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(245, 190, 50, 0.4);
  }
  
  .language-toggle-btn:active {
    transform: scale(0.98);
  }
  
  /* RTL Support */
  [dir="rtl"] .language-switcher {
    flex-direction: row-reverse;
  }
  </style> 